import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import React from 'react';

interface AutomaticGridProps {
  missingFields: boolean;
  automaticStepTemplateId: string;
  setAutomaticStepTemplateId: (value: string) => void;
  setStepName: (name: string) => void;
  setStepDescription: (description: string) => void;
  templateOptions: any[];
}

const AutomaticGrid: React.FC<AutomaticGridProps> = (props) => {
  const {
    missingFields,
    automaticStepTemplateId,
    setAutomaticStepTemplateId,
    setStepName,
    setStepDescription,
    templateOptions,
  } = props;
  return (
    <div style={{ paddingTop: '12px' }}>
      <FormControl fullWidth>
        <InputLabel id="template-label">Template</InputLabel>
        <Select
          error={missingFields && !automaticStepTemplateId}
          labelId="template-label"
          id="template-select"
          value={automaticStepTemplateId}
          onChange={(e) => {
            setAutomaticStepTemplateId(e.target.value);
            setStepName(
              templateOptions.find((template) => template.id === e.target.value)
                ?.name || '',
            );
            setStepDescription(
              templateOptions.find((template) => template.id === e.target.value)
                ?.name || '',
            );
          }}
          label="Template"
        >
          {templateOptions.map((template) => {
            return (
              <MenuItem key={template.id} value={template.id}>
                {template.name}
              </MenuItem>
            );
          })}
        </Select>
      </FormControl>
    </div>
  );
};

export default AutomaticGrid;
